$(function () {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    $('.hero-photo-slider').each((i, element) => {
        const hero = element.closest('.home-hero');
        element.querySelectorAll('.hero-slider-controls').forEach(controls => controls.remove());
        const slides = Array.from(element.children).filter(item => item.classList.contains('img'));
        if (slides.length < 2) return;
        let active = 0;
        let timer;
        let request = 0;
        let switching = false;
        let menuOpen = false;
        let darkTimer;
        let fadeTimer;
        let outgoing;
        let slideStarted = performance.now();
        let menuPausedAt = 0;
        const preloaded = new Map();

        function pause() {
            clearTimeout(timer);
        }
        function play() {
            pause();
            if (menuOpen || switching || reducedMotion.matches || document.hidden || hero.contains(document.activeElement)) return;
            const nextImage = slides[(active + 1) % slides.length].getAttribute('data-background-image');
            if (!preloaded.has(nextImage)) {
                const image = new Image();
                image.src = nextImage;
                preloaded.set(nextImage, image);
            }
            const remaining = Math.max(100, 4500 - (performance.now() - slideStarted));
            timer = setTimeout(() => show(active + 1), remaining);
        }
        function show(index) {
            pause();
            const next = (index + slides.length) % slides.length;
            const slide = slides[next];
            const image = new Image();
            const currentRequest = ++request;
            image.onload = () => {
                if (request !== currentRequest) return;
                slide.style.backgroundImage = `url(${JSON.stringify(image.src)})`;
                slide.setAttribute('data-loaded', 'true');
                function changeSlide() {
                    // Keep the outgoing image at its current scale while it fades out.
                    outgoing = slides[active];
                    outgoing.style.transform = window.getComputedStyle(outgoing).transform;
                    if (!reducedMotion.matches) outgoing.classList.add('is-outgoing');
                    slide.style.removeProperty('transform');
                    slides.forEach((item, slideIndex) => item.classList.toggle('is-active', slideIndex === next));
                    active = next;
                    slideStarted = performance.now();
                }
                if (reducedMotion.matches) {
                    changeSlide();
                    return;
                }
                switching = true;
                element.classList.add('is-switching');
                darkTimer = setTimeout(() => {
                    changeSlide();
                    element.classList.remove('is-switching');
                    fadeTimer = setTimeout(() => {
                        if (outgoing) outgoing.classList.remove('is-outgoing');
                        switching = false;
                        play();
                    }, 450);
                }, 300);
            };
            image.onerror = play;
            image.src = slide.getAttribute('data-background-image');
        }

        $(hero).on('focusin', pause).on('focusout', () => setTimeout(play, 0));
        document.addEventListener('visibilitychange', play);
        const menu = document.getElementById('navbarSupportedContent');
        if (menu) {
            menu.addEventListener('show.bs.offcanvas', () => {
                menuOpen = true;
                menuPausedAt = performance.now();
                pause();
                request++;
                clearTimeout(darkTimer);
                clearTimeout(fadeTimer);
                if (outgoing) outgoing.classList.remove('is-outgoing');
                switching = false;
                element.classList.remove('is-switching');
                element.classList.add('is-paused');
                const bounds = element.getBoundingClientRect();
                element.style.width = bounds.width + 'px';
                element.style.height = bounds.height + 'px';
            });
            menu.addEventListener('hidden.bs.offcanvas', () => {
                menuOpen = false;
                slideStarted += performance.now() - menuPausedAt;
                element.style.removeProperty('width');
                element.style.removeProperty('height');
                element.classList.remove('is-paused');
                play();
            });
        }
        if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', play);
        else reducedMotion.addListener(play);
        play();
    });
});
